import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'app-version-display',
  templateUrl: './version-display.component.html',
  styleUrls: ['./version-display.component.scss']
})
export class VersionDisplayComponent implements OnInit {
  version$!: Observable<string>;

  constructor(private versionService: VersionService) {}

  ngOnInit(): void {
    this.version$ = this.versionService.getVersion();
  }
}

